import { render, staticRenderFns } from "./RegimenReport.vue?vue&type=template&id=6d59d04b"
import script from "./RegimenReport.vue?vue&type=script&lang=js"
export * from "./RegimenReport.vue?vue&type=script&lang=js"
import style0 from "./RegimenReport.vue?vue&type=style&index=0&id=6d59d04b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports